<div class="bank-statement-seleect-transactions-dialog">
  <mat-dialog-content>
    <div class="row mb-4">
      <div class="col-12">
        <div class="mat-subtitle-1 header">Select Transactions</div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-lg-6 col-md-12">
        <div fxLayout="column">
          <mat-label class="mb-2">Search</mat-label>
          <mat-form-field fxFlex="1 1 auto" fxFlexAlign="start" class="search">
            <input matInput type="text" class="ml-4" placeholder="Search for transactions..." [formControl]="formControlSearch">
            <span class="mdi mdi-magnify" matPrefix></span>
          </mat-form-field>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div fxLayout="column">
          <mat-label class="mb-2">Filter by categories</mat-label>
          <mat-form-field fxFlex="1 1 auto" fxFlexAlign="start">
            <mat-select [formControl]="formControlCategory" placeholder="Filter by categories...">
              @for (option of categoryOptions; track option) {
                <mat-option [value]="option">{{option}}</mat-option>
              }
            </mat-select>
        </mat-form-field>
        </div>
      </div>
    </div>

    <div class="mb-4">
      <ng-container>
      <table mat-table [dataSource]="displayedData" class="width-100 mb-2" multiTemplateDataRows matSort (matSortChange)="onSort($event)">
        @for (column of columnsToDisplay; track column) {
          <ng-container matColumnDef="{{column}}">
        <th mat-header-cell mat-sort-header *matHeaderCellDef [arrowPosition]="needAlignRight(column) ? 'before' : 'after'" [ngClass]="{
          'column-width-2': column === 'date' || column === 'party',
          'column-width-3': column === 'transaction' || column === 'category' || column === 'otherInfo',
          'text-align-right': needAlignRight(column)
        }"> 
          <div class="cell">
            @if (column !== 'selector') {
              {{getColumnTitles(column)}}
            }
            @if (column === 'selector') {
              <span class="cursor-pointer mdi mdi-checkbox-multiple-blank-outline" (click)="toggleAllSelection()"></span>            
            }
          </div> 
        </th>
              <td mat-cell *matCellDef="let element" [ngClass]="{'text-align-right': needAlignRight(column)}">
                <div class="cell">
                  @if (column !== 'selector') {
                    @if(needCurrencyPipe(column)){
                      <span>{{ displayColumnValue(element, column) | looseCurrency }}</span>
                    }
                    @if(!needCurrencyPipe(column)){
                      <span>{{ displayColumnValue(element, column) }}</span>
                    }
                  }
                  @if (column === 'selector') {
                    <mat-checkbox color="primary" [formControl]="transactionFilter[element.id.toString()]"></mat-checkbox>
                  }
                </div>
              </td>
            </ng-container>
          }
  
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row {{toClass(element.category)}}">
          </tr>
        </table>
  
        @if (total<1) {
          <table class="not-found">
            <tr>
              <td> No data found </td>
            </tr>
          </table>
        }
      </ng-container>
  
      @if (total) {
        <app-custom-paginator [length]="total" [pageIndex]="offset" [pageSize]="limit"
        [pageSizeOptions]="[10, 20, 25, 50, 100]" (page)="onPagination($event)"></app-custom-paginator>
      }
    </div>

    <div class="row">
      <div class="col-12">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="width-100">
          <button color="primary" (click)="onCancel()" mat-stroked-button>Close</button>
          <button color="primary" (click)="onSubmit()" mat-flat-button>Confirm</button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
